import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Modal } from "react-bootstrap";
import word from "assets/img/file_word.png";
import excel from "assets/img/file_excel.png";
import pdf from "assets/img/file_pdf.png";
import ppt from "assets/img/file_pp.png";
import video from "assets/img/file_video.png";
import other from "assets/img/file_other.png";
import doc_upload from "assets/img/doc_upload.png";
import * as LotActionType from "../constants";
import Moment from "moment";
import { Dropdown } from "../../components/Dropdown/Dropdown";
import { Panel, Table } from "react-bootstrap";
import "../add-doc-modal.scss";
import heic2any from "heic2any";

export class AddDocumentModal extends Component {
  static propTypes = {
    isOpen: PropTypes.bool,
    closeModal: PropTypes.func,
    onDrop: PropTypes.func,
    accept: PropTypes.string,
    dispatch: PropTypes.func,
    homeownerLotSelectList: PropTypes.array,
    HomeownerDocumentCategory: PropTypes.object,
    lot: PropTypes.object,
    documentType: PropTypes.object,
    getDocumentByCategory: PropTypes.func,
    fetchListDocumentType: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.state = {
      isDragging: false,
      documents: [],
      uploading: false,
      uploadProgress: 0,
      uploadMessage: "",
      selectedLotId: null,
      lotDetails: null,
      activeKey: "1",
      showDocumentInfo: true,
      lot: this.props.lot,
      editingState: {},
      documentCategories: {},
      expandedPanels: {},
      editCategoryIndex: null,
      categoryErrors: {},
      nameErrors: {},
      textModified: false,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevProps.isOpen && this.props.isOpen) {
      this.setState({
        documents: [],
        documentCategories: {},
        expandedPanels: {},
        editingState: {},
        editCategoryIndex: null,
        errorMessage: "",
        uploadProgress: 0,
        uploadMessage: "",
        uploading: false,
        lot: this.props.lot,
      });

      if (!this.props.isOpen && prevProps.isOpen) {
        this.props.resetFileInput();
      }
    }

    if (prevProps.lot !== this.props.lot && this.props.lot) {
      this.setState({ lot: this.props.lot });
    }

    const prevLot = prevState.lot;
    const currentLot = this.state.lot;

    if (
      prevProps.HomeownerDocumentCategory !==
        this.props.HomeownerDocumentCategory &&
      this.props.HomeownerDocumentCategory.length > 0 &&
      this.state.activeKey === "1"
    ) {
      this.setState({ activeKey: "0" });
    }

    if (
      this.props.files &&
      this.props.files !== prevProps.files &&
      this.props.files.length > 0
    ) {
      const expandedPanels = { ...this.state.expandedPanels };
      this.props.files.forEach((_, index) => {
        if (!(index in expandedPanels)) {
          expandedPanels[index] = true;
        }
      });

      this.setState({ expandedPanels });
    }
  }

  togglePanel = (index) => {
    this.setState((prevState) => {
      const expandedPanels = {};
      const isCurrentlyOpen = prevState.expandedPanels[index];

      if (!isCurrentlyOpen) {
        expandedPanels[index] = true;
      }

      return { expandedPanels };
    });
  };

  onEditStart = (index) => {
    this.setState((prevState) => ({
      editingState: {
        ...prevState.editingState,
        [index]: true,
      },
    }));
  };

  onEditCancel = (index) => {
    this.setState((prevState) => {
      const updatedDocuments = [...prevState.documents];
      const file = updatedDocuments[index];

      if (file.originalName !== undefined) {
        file.overrideName = file.originalName;
      }

      const updatedNameErrors = { ...prevState.nameErrors };
      delete updatedNameErrors[index];
      return {
        documents: updatedDocuments,
        editingState: {
          ...prevState.editingState,
          [index]: false,
        },
        nameErrors: updatedNameErrors,
      };
    });
  };

  onFileNameChange = (index, newName) => {
    this.setState((prevState) => {
      const updatedFiles = [...prevState.documents];
      const originalName =
        updatedFiles[index].originalName || updatedFiles[index].name;
      const originalExtension = originalName.split(".").pop();

      // Remove extension from user input if they try to change it
      let cleanName = newName;
      const inputParts = newName.split(".");
      if (inputParts.length > 1) {
        cleanName = inputParts.slice(0, -1).join(".");
      }

      const finalName = `${cleanName}.${originalExtension}`;
      updatedFiles[index].overrideName = finalName;
      updatedFiles[index].textModified = true;

      const updatedNameErrors = { ...prevState.nameErrors };
      if (cleanName.trim() !== "") {
        delete updatedNameErrors[index];
      }
      if (cleanName.trim() === "") {
        updatedNameErrors[index] = "Document name cannot be empty.";
      }
      return {
        documents: updatedFiles,
        nameErrors: updatedNameErrors,
      };
    });
  };

  onSubmit = () => {
    const {
      documents,
      documentCategories,
      lot,
      editCategoryIndex,
      editingState,
    } = this.state;
    const { builderProfile } = lot.extensionValue;
    const defaultCategory = this.props.documentType;

    let hasError = false;
    const categoryErrors = {};
    const nameErrors = {};
    Object.values(documentCategories).forEach((item, index) => {
      if (editCategoryIndex == index) {
        if (item == null) {
          hasError = true;
          categoryErrors[index] = "Category is required.";
        }
      }
    });

    documents.forEach((file, index) => {
      const name =
        file.overrideName !== undefined ? file.overrideName : file.name;
      const nameWithoutExt = name.replace(/\.[^/.]+$/, "").trim();
      if (!nameWithoutExt) {
        hasError = true;
        nameErrors[index] = "Document name is required.";
      }
    });

    if (hasError) {
      this.setState({ categoryErrors, nameErrors });
      return;
    }

    const formData = new FormData();
    documents.forEach((file, index) => {
      const originalName = file.name || "";
      const extension = originalName.substring(originalName.lastIndexOf("."));

      let baseName =
        file.overrideName !== undefined
          ? file.overrideName.replace(/\.[^/.]+$/, "").trim()
          : originalName.replace(/\.[^/.]+$/, "").trim();

      if (!baseName) {
        baseName = originalName.replace(/\.[^/.]+$/, "").trim();
      }

      const fileName = `${baseName}${extension}`;
      let category = documentCategories[index];
      if (category && typeof category === "object") {
        category = category.value;
      } else {
        category = defaultCategory ? defaultCategory.value : null;
      }

      formData.append(`lotDocuments[${index}].DocumentFile`, file);
      formData.append(`lotDocuments[${index}].LotId`, lot.value);
      formData.append(`lotDocuments[${index}].DocCategoryId`, category);
      formData.append(`lotDocuments[${index}].FileName`, fileName);
    });

    this.setState({ uploading: true, uploadProgress: 0 });

    this.props.dispatch({
      type: LotActionType.UPLOAD_DOCUMENT_BY_CATEGORY_ASYNC,
      params: {
        headers: {
          url: builderProfile.builderHost,
        },
        data: formData,
      },
      callback: () => {
        this.setState(
          {
            files: [],
            cancelUploadList: {},
            deleteUploadList: {},
            showModal: false,
            uploadedFiles: [],
            showEditModal: false,
            menuOpenId: null,
            selectedDocument: null,
            uploading: false,
          },
          () => {
            this.props.fetchListDocumentType();
            this.props.closeModal();
          }
        );
      },
    });
  };

  handleDragOver = (e) => {
    e.preventDefault();
    this.setState({ isDragging: true });
  };

  handleDragLeave = () => {
    this.setState({ isDragging: false });
  };

  handleDrop = (e) => {
    e.preventDefault();
    this.setState({ isDragging: false });

    const files = Array.from(e.dataTransfer.files);

    const accepted = [];
    const rejected = [];

    files.forEach((file) => {
      if (
        ["application/pdf", "image/png", "image/jpg", "image/jpeg", "image/webp"].includes(
          file.type
        )
      ) {
        accepted.push(file);
      } else {
        rejected.push(file);
      }
    });

    if (this.props.onDrop) {
      this.props.onDrop(accepted, rejected);
    }
  };

  formatDate = (date) => {
    const d = new Date(date);
    return d.toLocaleDateString();
  };

  onEditTabName = (index) => {
    this.setState({ editCategoryIndex: index });
  };

  // handleFileChange = async (e) => {
  //   const selectedFiles = Array.from(e.target.files);
  //   const currentDocuments = this.state.documents;
  //   const currentCategories = this.state.documentCategories;

  //   const allFiles = [...currentDocuments, ...selectedFiles];
  //   if (allFiles.length > 5) {
  //     this.setState({ errorMessage: "You can select up to 5 documents." });
  //     return;
  //   }

  //   const accepted = [];
  //   const rejected = [];

  //   selectedFiles.forEach((file) => {
  //     const isAcceptedType = [
  //       "application/pdf",
  //       "image/png",
  //       "image/jpg",
  //       "image/jpeg",
  //       "image/heic", "image/heif",
  //       "application/msword",
  //       "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  //       "application/vnd.ms-excel",
  //       "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  //     ].includes(file.type);

  //     const isValidSize = file.size <= 5 * 1024 * 1024;

  //     if (isAcceptedType && isValidSize) {
  //       accepted.push(file);
  //     } else {
  //       rejected.push(file);
  //     }
  //   });

  //   if (rejected.length > 0) {
  //     this.setState({
  //       errorMessage: "Each file must be under 100MB and a valid file type. Type allowed: jpg, png, jpeg, heic, pdf, word, excel",
  //     });
  //     return;
  //   }

  //   if (this.props.onDrop) {
  //     this.props.onDrop(accepted, rejected);
  //   }

  //   const updatedDocuments = [...currentDocuments, ...accepted];
  //   const updatedCategories = { ...currentCategories };
  //   const expandedPanels = { ...this.state.expandedPanels };
  //   const editingState = { ...this.state.editingState };
  //   const defaultCategory = this.props.documentType;
  //   const defaultCategoryValue =
  //     defaultCategory && defaultCategory.length > 0
  //       ? defaultCategory[0].value
  //       : null;

  //   accepted.forEach((file, index) => {
  //     const docIndex = currentDocuments.length + index;
  //     updatedCategories[docIndex] = defaultCategoryValue;
  //     file.originalName = file.name;
  //     expandedPanels[docIndex] = true;
  //     editingState[docIndex] = false;
  //   });

  //   this.setState({
  //     documents: updatedDocuments,
  //     documentCategories: updatedCategories,
  //     expandedPanels,
  //     editingState,
  //     errorMessage: "",
  //   });
  // };

  handleFileChange = async (e) => {
    const selectedFiles = Array.from(e.target.files);
    const currentDocuments = this.state.documents;
    const currentCategories = this.state.documentCategories;

    const allFiles = [...currentDocuments, ...selectedFiles];
    if (allFiles.length > 100) {
      this.setState({ errorMessage: "You can select up to 5 documents." });
      return;
    }

    const accepted = [];
    const rejected = [];

    selectedFiles.forEach((file) => {
      const isAcceptedType = [
        "application/pdf",
        "image/png",
        "image/jpg",
        "image/jpeg",
        "image/heic",
        "image/heif",
        "image/webp",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      ].includes(file.type);

      const isValidSize = file.size <= 100 * 1024 * 1024;

      if (isAcceptedType && isValidSize) {
        accepted.push(file);
      } else {
        rejected.push(file);
      }
    });

    if (rejected.length > 0) {
      this.setState({
        errorMessage:
          "Each file must be under 100MB and a valid file type. Type allowed: jpg, png, jpeg, heic, webp, pdf, word, excel",
      });
      return;
    }
    const processedFiles = [];
    for (const file of accepted) {
      if (file.type === "image/heic" || file.type === "image/heif") {
        try {
          const convertedBlob = await heic2any({
            blob: file,
            toType: "image/jpeg",
            quality: 0.8,
          });

          const newFileName = `${file.name.split(".")[0]}.jpeg`;
          const convertedFile = new File([convertedBlob], newFileName, {
            type: "image/jpeg",
            lastModified: file.lastModified,
          });

          processedFiles.push(convertedFile);
        } catch (error) {
          console.error("HEIC conversion failed:", error);
          processedFiles.push(file);
        }
      } else {
        processedFiles.push(file);
      }
    }

    if (this.props.onDrop) {
      this.props.onDrop(processedFiles, rejected);
    }

    const updatedDocuments = [...currentDocuments, ...processedFiles];
    const updatedCategories = { ...currentCategories };
    const expandedPanels = { ...this.state.expandedPanels };
    const editingState = { ...this.state.editingState };
    const defaultCategory = this.props.documentType;
    const defaultCategoryValue =
      defaultCategory && defaultCategory.length > 0
        ? defaultCategory[0].value
        : null;

    processedFiles.forEach((file, index) => {
      const docIndex = currentDocuments.length + index;
      updatedCategories[docIndex] = defaultCategoryValue;
      file.originalName = file.name.split(".")[0];
      expandedPanels[docIndex] = true;
      editingState[docIndex] = false;
    });

    this.setState({
      documents: updatedDocuments,
      documentCategories: updatedCategories,
      expandedPanels: expandedPanels,
      editingState,
      errorMessage: "",
    });
  };

  fetchListDocumentType = () => {
    const { lot } = this.props;

    const { builderProfile } = lot.extensionValue;

    this.props.dispatch({
      type: LotActionType.GET_HOMEOWNER_DOCUMENT_CATEGORY_ASYNC,
      params: {
        headers: {
          url: builderProfile.builderHost,
        },
        lotId: lot.value,
      },
    });
  };

  onSelectLot = (event) => {
    this.setState({
      lot: event.value,
    });
  };

  renderFileTypeIcon = (item) => {
    const extWord = ["doc", "docx"];
    const extExcel = ["xls", "xlsx"];
    const extPpt = ["ppt", "pptx"];
    const extImage = ["jpg", "jpeg", "png", "gif", "webp"];
    const extVideo = ["mp4", "m4v", "mid", "mkv", "webm", "mov", "avi", "wmv"];

    const fileName = item.fileName || item.name;
    if (!fileName) return other;

    const ext = fileName.split(".").pop().toLowerCase();

    if (extWord.includes(ext)) {
      return word;
    } else if (extExcel.includes(ext)) {
      return excel;
    } else if (extPpt.includes(ext)) {
      return ppt;
    } else if (extVideo.includes(ext)) {
      return video;
    } else if (ext === "pdf") {
      return pdf;
    } else if (extImage.includes(ext)) {
      return item.url || URL.createObjectURL(item);
    } else {
      return other;
    }
  };

  renderHomeownerFiles = () => {
    const { documents } = this.state;
    const files = documents || [];
    const { homeownerLotSelectList, HomeownerDocumentCategory, documentType } =
      this.props;
    const {
      activeKey,
      lot,
      documentCategory,
      showDocumentInfo,
      itemEdit,
      documentCategories,
    } = this.state;
    return (
      <div className="file-entry">
        {files.map((file, index) => {
          const isExpanded = this.state.expandedPanels[index];
          return (
            <div className="add-document-list" key={index}>
              <div className="file-summary">
                <img src={this.renderFileTypeIcon(file)} className="doc-icon" />
                <div className="file-info">
                  <p className="file-name" style={{ marginBottom: "0px" }}>
                    {file.name}
                  </p>
                  <span className="sub-title-doc">{lot.text}</span>
                  <span className="sub-title-doc">
                    {Moment().format("MM/DD/YYYY")}
                  </span>
                </div>
              </div>

              <Panel>
                <Panel.Heading onClick={() => this.togglePanel(index)}>
                  <div className="accordion-header-add-edit">
                    <span>
                      <i
                        class="fa fa-file-text-o doc-icon"
                        aria-hidden="true"
                      ></i>

                      <span className="lot-titles">Document Info</span>
                    </span>
                    <span
                      className={`glyphicon arrow-icon ${
                        this.state.expandedPanels[index]
                          ? "glyphicon-chevron-up"
                          : "glyphicon-chevron-down"
                      }`}
                    ></span>
                  </div>
                </Panel.Heading>

                {this.state.expandedPanels[index] && (
                  <Panel.Body>
                    <Table bordered className="accordion-table-doc">
                      <tbody>
                        <tr>
                          <th>Title</th>
                          <td>
                            {this.state.editingState[index] ? (
                              <span>
                                <input
                                  type="text"
                                  minLength="2"
                                  maxLength="40"
                                  name="name"
                                  value={(file.overrideName !== undefined
                                    ? file.overrideName
                                    : file.name
                                  ).replace(/\.[^/.]+$/, "")}
                                  onChange={(e) => {
                                    const nameWithoutExt =
                                      e.target.value.replace(/\.[^/.]+$/, "");
                                    this.onFileNameChange(
                                      index,
                                      nameWithoutExt
                                    );
                                  }}
                                  style={{ width: "80%" }}
                                />
                                <span style={{ marginLeft: 5 }}>
                                  .{file.name.split(".").pop()}
                                </span>
                                <i
                                  className="fa fa-times"
                                  style={{ marginLeft: 10, cursor: "pointer" }}
                                  onClick={() => this.onEditCancel(index)}
                                ></i>
                                {this.state.nameErrors[index] && (
                                  <div className="validation-message">
                                    {this.state.nameErrors[index]}
                                  </div>
                                )}
                              </span>
                            ) : (
                              <span>
                                {file.overrideName || file.name}
                                <span
                                  className="fa fa-pencil tab-title-edit-icon"
                                  style={{ color: "#4a4a4a", marginLeft: 5 }}
                                  onClick={() => this.onEditStart(index)}
                                />
                              </span>
                            )}
                          </td>
                        </tr>

                        <tr>
                          <th>Property</th>
                          <td>
                            <span>{lot.text}</span>
                          </td>
                        </tr>
                        <tr>
                          <th>Category</th>
                          <td>
                            {this.state.editCategoryIndex == index ? (
                              <div className="select-category">
                                <Dropdown
                                  onChange={(event) =>
                                    this.onSelectCategory(event, index)
                                  }
                                  required={true}
                                  filter={true}
                                  className="filestring-dropdown filter-dropdown"
                                  options={HomeownerDocumentCategory}
                                  optionLabel="text"
                                  onRemote={this.fetchListDocumentType}
                                  value={
                                    this.state.documentCategories[index] || null
                                  }
                                  style={{
                                    width: "100%",
                                    display: "inline-block",
                                  }}
                                  name="category"
                                  placeholder="-- Please select"
                                />
                                {this.state.categoryErrors[index] && (
                                  <div
                                    className="validation-message"
                                    style={{ color: "red", marginTop: 2 }}
                                  >
                                    {this.state.categoryErrors[index]}
                                  </div>
                                )}
                              </div>
                            ) : (
                              <span>
                                {this.state.documentCategories[index] &&
                                typeof this.state.documentCategories[index] ===
                                  "object"
                                  ? this.state.documentCategories[index].text
                                  : documentType.text}
                                <span
                                  id={file.value}
                                  className="fa fa-pencil tab-title-edit-icon"
                                  style={{ color: "#4a4a4a", marginLeft: 5 }}
                                  onClick={() => this.onEditTabName(index)}
                                />
                              </span>
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </Panel.Body>
                )}
              </Panel>

              <button
                className="delete-btn"
                onClick={() => this.removeFile(index)}
              >
                Delete File
              </button>
            </div>
          );
        })}
      </div>
    );
  };

  removeFile = (index) => {
    const documents = [...this.state.documents];
    documents.splice(index, 1);

    const documentCategories = { ...this.state.documentCategories };
    delete documentCategories[index];

    const expandedPanels = { ...this.state.expandedPanels };
    delete expandedPanels[index];

    const editingState = { ...this.state.editingState };
    delete editingState[index];

    const reindexObject = (obj) => {
      const newObj = {};
      Object.values(obj).forEach((value, newIndex) => {
        newObj[newIndex] = value;
      });
      return newObj;
    };

    this.setState({
      documents,
      documentCategories: reindexObject(documentCategories),
      expandedPanels: reindexObject(expandedPanels),
      editingState: reindexObject(editingState),
    });
    if (this.fileInput) {
      this.fileInput.value = "";
    }
  };

  onSelectCategory = (event, index) => {
    const updatedCategories = { ...this.state.documentCategories };
    updatedCategories[index] = event.value || event;

    const categoryErrors = { ...this.state.categoryErrors };
    delete categoryErrors[index];

    this.setState({
      documentCategories: updatedCategories,
      categoryErrors,
    });
  };

  render() {
    const { isDragging, documents } = this.state;
    const { isOpen, closeModal, accept } = this.props;
    return (
      <Modal
        show={isOpen}
        onHide={closeModal}
        backdrop="static"
        dialogClassName="slide-in-modal"
        className="modal-right"
      >
        <Modal.Header className="modal-header-profile">
          <div className="modal-header">
            <i
              className="fa fa-chevron-left arrow-btn"
              aria-hidden="true"
              onClick={closeModal}
            ></i>
            <Modal.Title className="modal-title-custom">
              New Document
            </Modal.Title>
          </div>
        </Modal.Header>

        <Modal.Body className="modal-body-add-doc scrollable-modal-body">
          {this.state.uploadMessage && (
            <div className="upload-status-footer">
              <span>{this.state.uploadMessage}</span>
              {this.state.uploading && (
                <span>{this.state.uploadProgress}%</span>
              )}
            </div>
          )}
          {documents && this.renderHomeownerFiles(this.props.LotDocuments)}
          {this.state.errorMessage && (
            <div
              className="error-message"
              style={{ color: "red", marginBottom: "10px" }}
            >
              {this.state.errorMessage}
            </div>
          )}

          <div className="image-upload-section-add">
            <img
              className="doc-img-upload"
              onClick={() => this.fileInput.click()}
              src={doc_upload}
              alt="Upload"
            />
            <p className="muted-msg">
              Upload a file from your computer. Upload Files only below 100MB
            </p>
            <div
              className={`modal-dropzone ${isDragging ? "dragging" : ""}`}
              onDragOver={this.handleDragOver}
              onDragLeave={this.handleDragLeave}
              onDrop={this.handleDrop}
            >
              <input
                type="file"
                accept={accept}
                multiple
                onChange={this.handleFileChange}
                style={{ display: "none" }}
                ref={(ref) => (this.fileInput = ref)}
              />
              <button
                type="button"
                className="add-doc-upload-document-btn"
                onClick={() => this.fileInput.click()}
              >
                <i className="fa fa-cloud-upload" aria-hidden="true"></i>
                Upload Files
              </button>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="modal-footer-addDocument">
          {this.state.documents.length > 0 ? (
            <button className="save-doc-btn" onClick={this.onSubmit}>
              Save Documents
            </button>
          ) : (
            ""
          )}
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    LotDocuments: state.LotStore.LotDocuments,
    homeownerLotSelectList: state.LotStore.HomeownerLotSelectList,
    HomeownerDocumentCategory: state.LotStore.HomeownerDocumentCategory,
  };
};

export default connect(mapStateToProps)(AddDocumentModal);



// WEBPACK FOOTER //
// ./src/Lots/Components/AddDocumentModal.js